import { Home, Sparkles, ShoppingBag, Clock } from "lucide-react";

const ITEMS = [
  { icon: Home, label: "Fait maison à Carcassonne" },
  { icon: Sparkles, label: "Préparé frais" },
  { icon: ShoppingBag, label: "Click & Collect" },
  { icon: Clock, label: "Commande simple & rapide" },
];

export const Reassurance = () => (
  <section className="py-10 md:py-14" data-testid="reassurance">
    <div className="max-w-5xl mx-auto px-5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-5">
        {ITEMS.map((it) => {
          const Icon = it.icon;
          return (
            <div
              key={it.label}
              className="bg-white/80 backdrop-blur-md rounded-2xl px-4 py-5 text-center border border-amyu/30 hover:border-coral/40 transition-all"
            >
              <Icon size={22} className="text-coral mx-auto mb-2" />
              <div className="text-xs md:text-sm font-medium text-amyu-ink leading-tight">
                {it.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
